import { SHOW_EVENTS } from '@/config';

export const SITE = {
  name: 'Indian Technical Education Society – Mumbai',
  phone: '022 2166 1295',
  phoneHref: 'tel:02221661295',
  mobile: '+91 88980 13258',
  mobileHref: 'tel:+918898013258',
  email: 'itesmumbai@gmail.com',
  emailHref: 'mailto:itesmumbai@gmail.com',
  addressLines: ['B-1011/1012, Station Plaza, Station Road', 'Bhandup (W), Mumbai 400078', 'Maharashtra, India'],
  mapsUrl:
    'https://www.google.com/maps/search/?api=1&query=Station+Plaza+Station+Road+Bhandup+West+Mumbai+400078',
} as const;

export const NAV = [
  { label: 'About', to: '/about' },
  { label: 'Courses', to: '/courses' },
  { label: 'Examinations', to: '/examinations' },
  { label: 'Affiliation', to: '/affiliation' },
  { label: 'Centres', to: '/centres' },
  { label: 'Notices', to: '/notices' },
  { label: 'E-Journal', to: '/e-journal' },
  { label: 'Contact', to: '/contact' },
] as const;

// Events is not in the main bar. It appears in the mobile menu and the footer only while SHOW_EVENTS is true.
export const MOBILE_NAV: { label: string; to: string }[] = [
  { label: 'Home', to: '/' },
  ...NAV,
  ...(SHOW_EVENTS ? [{ label: 'Events', to: '/events' }] : []),
];
